import axios from 'axios';
import qs from 'qs';
// import localStorage from 'store';
import notification from 'ant-design-vue/es/notification';

/** Java 服务根地址 */
// export const JAVA_BASE_URL = 'http://192.168.1.148:8090';
export const JAVA_BASE_URL = 'https://api.love1234.com';

const javaRequest = axios.create({
	baseURL: JAVA_BASE_URL,
	timeout: 30000,
});

const errorHandler = (error) => {
	if (error.response) {
		const status = error.response.status;
		if (status === 403) {
			notification.error({ message: '权限不足', description: '你没有该权限' });
		} else if (status === 404) {
			notification.error({ message: '404', description: '资源不存在' });
		} else if (status === 401) {
			notification.error({ message: '未登录', description: '你还没有登录，或登录已过期' });
		} else if (status >= 500) {
			console.error(error.response.data);
			notification.error({ message: '服务异常', description: 'Java 接口请求失败' });
		}
	}
	return Promise.reject(error);
};

// javaRequest.interceptors.request.use((config) => {
// 	const token = localStorage.get('admin.token');
// 	if (token) {
// 		config.headers.token = token;
// 	}
// 	return config;
// }, errorHandler);

javaRequest.interceptors.response.use((response) => {
	const res = response.data;
	if (res && typeof res === 'object') {
		const code = res.code;
		res.isSucceed = code === 200 || code === 'OK' || res.success === true;
	}
	return res;
}, errorHandler);

/**
 * GET 请求 Java 接口
 * @param {string} url 路径，如 /vod/playList
 * @param {object} [params] 查询参数
 */
export function javaRequestGet(url, params) {
	let path = url;
	if (params && Object.keys(params).length !== 0) {
		path += '?' + qs.stringify(params);
	}
	return javaRequest({ url: path, method: 'GET' });
}

/**
 * POST 请求 Java 接口（JSON）
 * @param {string} url
 * @param {object} [data] 请求体
 */
export function javaRequestPost(url, data) {
	return javaRequest({
		url,
		method: 'POST',
		data: data || {},
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	});
}

/**
 * 点播播放列表：GET /vod/playList
 * @param {object} videoUrl 查询参数
 */
export async function vodPlayList(videoUrl) {
    const params = {
        videoUrl: videoUrl,
    }
	return javaRequestGet('/vod/playList', params);
}

export { javaRequest };
